import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { X, ZoomIn, CreditCard, Store, Lightbulb, CheckCircle2 } from 'lucide-react';

export default function PetunjukLoginModal({ open, onClose, defaultTab = 'karyawan' }) {
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [zoomedImage, setZoomedImage] = useState(null);

  if (!open) return null;

  const content = (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            height: '100dvh',
            zIndex: 999999,
            background: 'rgba(15, 23, 42, 0.65)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
            boxSizing: 'border-box',
          }}
          onClick={onClose}
        >
          <motion.div
            initial={{ y: 24, scale: 0.96, opacity: 0 }}
            animate={{ y: 0, scale: 1, opacity: 1 }}
            exit={{ y: 16, scale: 0.98, opacity: 0 }}
            transition={{ type: 'spring', damping: 26, stiffness: 350 }}
            style={{
              width: '100%',
              maxWidth: 480,
              maxHeight: '90vh',
              maxHeight: '90dvh',
              overflowY: 'auto',
              background: '#ffffff',
              borderRadius: 24,
              boxShadow: '0 25px 60px rgba(15, 23, 42, 0.35)',
              border: '1px solid rgba(226, 232, 240, 0.9)',
              fontFamily: "'Segoe UI', Roboto, sans-serif",
              textAlign: 'left',
              boxSizing: 'border-box',
              margin: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              style={{
                padding: '18px 20px 14px',
                borderBottom: '1px solid #f1f5f9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)',
                borderTopLeftRadius: 24,
                borderTopRightRadius: 24,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 12,
                    background: 'linear-gradient(135deg, #0284c7, #0369a1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#ffffff',
                    boxShadow: '0 4px 10px rgba(2, 132, 199, 0.28)',
                  }}
                >
                  <Lightbulb size={20} />
                </div>
                <div>
                  <h3
                    style={{
                      margin: 0,
                      fontSize: 17,
                      fontWeight: 800,
                      color: '#0f172a',
                      letterSpacing: '-0.3px',
                    }}
                  >
                    Petunjuk Login
                  </h3>
                  <p
                    style={{
                      margin: '2px 0 0',
                      fontSize: 12,
                      color: '#64748b',
                      fontWeight: 500,
                    }}
                  >
                    Contoh format NIK Karyawan & Kode. Debitur
                  </p>
                </div>
              </div>

              <button
                type="button"
                onClick={onClose}
                aria-label="Tutup petunjuk"
                style={{
                  border: 'none',
                  background: '#f1f5f9',
                  color: '#475569',
                  borderRadius: '50%',
                  width: 32,
                  height: 32,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#e2e8f0';
                  e.currentTarget.style.color = '#0f172a';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#f1f5f9';
                  e.currentTarget.style.color = '#475569';
                }}
              >
                <X size={18} />
              </button>
            </div>

            {/* Segmented Tab Switcher */}
            <div style={{ padding: '14px 20px 8px' }}>
              <div
                style={{
                  display: 'flex',
                  background: '#f1f5f9',
                  padding: 4,
                  borderRadius: 14,
                  gap: 4,
                  border: '1px solid #e2e8f0',
                }}
              >
                <button
                  type="button"
                  onClick={() => setActiveTab('karyawan')}
                  style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 7,
                    padding: '8px 12px',
                    borderRadius: 10,
                    border: 'none',
                    fontSize: 13,
                    fontWeight: 700,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    background: activeTab === 'karyawan' ? '#ffffff' : 'transparent',
                    color: activeTab === 'karyawan' ? '#0284c7' : '#64748b',
                    boxShadow:
                      activeTab === 'karyawan'
                        ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                        : 'none',
                  }}
                >
                  <CreditCard size={15} />
                  <span>NIK Karyawan</span>
                </button>

                <button
                  type="button"
                  onClick={() => setActiveTab('agen')}
                  style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 7,
                    padding: '8px 12px',
                    borderRadius: 10,
                    border: 'none',
                    fontSize: 13,
                    fontWeight: 700,
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    background: activeTab === 'agen' ? '#ffffff' : 'transparent',
                    color: activeTab === 'agen' ? '#0f766e' : '#64748b',
                    boxShadow:
                      activeTab === 'agen'
                        ? '0 2px 8px rgba(0, 0, 0, 0.08)'
                        : 'none',
                  }}
                >
                  <Store size={15} />
                  <span>Kode. Debitur Agen</span>
                </button>
              </div>
            </div>

            {/* Tab Body */}
            <div style={{ padding: '10px 20px 20px', flex: 1 }}>
              {activeTab === 'karyawan' ? (
                <div>
                  <div
                    style={{
                      background: '#eff6ff',
                      border: '1px solid #bfdbfe',
                      borderRadius: 14,
                      padding: '12px 14px',
                      marginBottom: 14,
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                      <CheckCircle2 size={16} color="#2563eb" />
                      <span style={{ fontSize: 13, fontWeight: 700, color: '#1e40af' }}>
                        Format NIK Karyawan
                      </span>
                    </div>
                    <p style={{ margin: 0, fontSize: 12.5, color: '#334155', lineHeight: 1.5 }}>
                      Bagi Karyawan JNE, gunakan <strong>NIK</strong> yang tertera pada bagian paling bawah <strong>ID Card</strong> Anda (diawali dengan <strong>CXP</strong>, misalnya: <span style={{ fontFamily: 'monospace', fontWeight: 700, background: '#dbeafe', padding: '1px 6px', borderRadius: 4 }}>CXP 24-02-XXXX</span>).
                    </p>
                  </div>

                  {/* Image Card */}
                  <div
                    onClick={() => setZoomedImage({ src: '/nik.png', alt: 'Contoh NIK ID Card Karyawan' })}
                    style={{
                      position: 'relative',
                      background: '#f8fafc',
                      borderRadius: 16,
                      border: '1.5px solid #cbd5e1',
                      overflow: 'hidden',
                      cursor: 'zoom-in',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 10,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.04)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.08)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.04)';
                    }}
                  >
                    <img
                      src="/nik.png"
                      alt="Contoh NIK pada ID Card Karyawan"
                      style={{
                        maxWidth: '100%',
                        maxHeight: 280,
                        objectFit: 'contain',
                        borderRadius: 10,
                        display: 'block',
                      }}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        bottom: 12,
                        right: 12,
                        background: 'rgba(15, 23, 42, 0.78)',
                        backdropFilter: 'blur(4px)',
                        color: '#ffffff',
                        padding: '4px 10px',
                        borderRadius: 20,
                        fontSize: 11,
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 5,
                      }}
                    >
                      <ZoomIn size={12} />
                      <span>Klik untuk memperbesar</span>
                    </div>
                  </div>

                  {/* Hint info */}
                  <div
                    style={{
                      marginTop: 12,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 8,
                      fontSize: 11.5,
                      color: '#64748b',
                      lineHeight: 1.45,
                    }}
                  >
                    <span style={{ fontSize: 13 }}>💡</span>
                    <span>
                      Anda dapat memasukkan NIK secara langsung (contoh: <code>CXP2402XXXX</code>). Sistem akan otomatis memvalidasi ke server.
                    </span>
                  </div>
                </div>
              ) : (
                <div>
                  <div
                    style={{
                      background: '#f0fdf4',
                      border: '1px solid #bbf7d0',
                      borderRadius: 14,
                      padding: '12px 14px',
                      marginBottom: 14,
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                      <CheckCircle2 size={16} color="#16a34a" />
                      <span style={{ fontSize: 13, fontWeight: 700, color: '#166534' }}>
                        Kode. Debitur Agen
                      </span>
                    </div>
                    <p style={{ margin: 0, fontSize: 12.5, color: '#334155', lineHeight: 1.5 }}>
                      Bagi Mitra Agen JNE, gunakan <strong>Kode. Debitur</strong> yang tertera pada bagian <strong>"Kode"</strong> di layar utama sistem <strong>JNE HYBRID</strong> (contoh: <span style={{ fontFamily: 'monospace', fontWeight: 700, background: '#dcfce7', padding: '1px 6px', borderRadius: 4 }}>101XXXX</span>).
                    </p>
                  </div>

                  {/* Image Card */}
                  <div
                    onClick={() => setZoomedImage({ src: '/debitur.png', alt: 'Contoh Kode. Debitur JNE HYBRID' })}
                    style={{
                      position: 'relative',
                      background: '#f8fafc',
                      borderRadius: 16,
                      border: '1.5px solid #cbd5e1',
                      overflow: 'hidden',
                      cursor: 'zoom-in',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 10,
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.04)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.08)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.04)';
                    }}
                  >
                    <img
                      src="/debitur.png"
                      alt="Contoh Kode. Debitur pada JNE HYBRID"
                      style={{
                        maxWidth: '100%',
                        maxHeight: 280,
                        objectFit: 'contain',
                        borderRadius: 10,
                        display: 'block',
                      }}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        bottom: 12,
                        right: 12,
                        background: 'rgba(15, 23, 42, 0.78)',
                        backdropFilter: 'blur(4px)',
                        color: '#ffffff',
                        padding: '4px 10px',
                        borderRadius: 20,
                        fontSize: 11,
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 5,
                      }}
                    >
                      <ZoomIn size={12} />
                      <span>Klik untuk memperbesar</span>
                    </div>
                  </div>

                  {/* Hint info */}
                  <div
                    style={{
                      marginTop: 12,
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 8,
                      fontSize: 11.5,
                      color: '#64748b',
                      lineHeight: 1.45,
                    }}
                  >
                    <span style={{ fontSize: 13 }}>💡</span>
                    <span>
                      Akun Agen JNE tidak memerlukan pengecekan Device ID, sehingga dapat divalidasi langsung di perangkat manapun.
                    </span>
                  </div>
                </div>
              )}

              {/* Close Button Footer */}
              <div style={{ marginTop: 18, textAlign: 'center' }}>
                <button
                  type="button"
                  onClick={onClose}
                  style={{
                    width: '100%',
                    padding: '12px 18px',
                    borderRadius: 14,
                    border: 'none',
                    background: activeTab === 'karyawan'
                      ? 'linear-gradient(135deg, #0284c7, #0369a1)'
                      : 'linear-gradient(135deg, #0f766e, #115e59)',
                    color: '#ffffff',
                    fontSize: 14,
                    fontWeight: 700,
                    cursor: 'pointer',
                    boxShadow: '0 4px 14px rgba(2, 132, 199, 0.25)',
                    transition: 'all 0.2s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = '0.92';
                    e.currentTarget.style.transform = 'translateY(-1px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  Saya Mengerti
                </button>
              </div>
            </div>
          </motion.div>

          {/* Lightbox / Zoom Overlay */}
          <AnimatePresence>
            {zoomedImage && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                style={{
                  position: 'fixed',
                  inset: 0,
                  zIndex: 1000000,
                  background: 'rgba(0, 0, 0, 0.88)',
                  backdropFilter: 'blur(10px)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 16,
                  boxSizing: 'border-box',
                }}
                onClick={() => setZoomedImage(null)}
              >
                <button
                  type="button"
                  onClick={() => setZoomedImage(null)}
                  style={{
                    position: 'absolute',
                    top: 20,
                    right: 20,
                    background: 'rgba(255, 255, 255, 0.2)',
                    border: 'none',
                    color: '#ffffff',
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    fontSize: 20,
                  }}
                >
                  <X size={24} />
                </button>

                <motion.img
                  initial={{ scale: 0.85 }}
                  animate={{ scale: 1 }}
                  exit={{ scale: 0.85 }}
                  transition={{ type: 'spring', damping: 25 }}
                  src={zoomedImage.src}
                  alt={zoomedImage.alt}
                  style={{
                    maxWidth: '92vw',
                    maxHeight: '85vh',
                    objectFit: 'contain',
                    borderRadius: 12,
                    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5)',
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return typeof document !== 'undefined' ? createPortal(content, document.body) : content;
}
